import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';

export const useAskSearchChoice = () => {
  const { query, events } = useRouter();
  /*const previousQuery = useRef<{ [key: string]: string } | null>(null);

  useEffect(() => {
    if (events) {
      const handleRouteWillChanged = () => {
        previousQuery.current = query;
      };

      events.on('routeChangeStart', handleRouteWillChanged);
      return () => {
        events.off('routeChangeStart', handleRouteWillChanged);
      };
    }
  }, [events, query]);

  if (previousQuery.current?.reference && query.reference) {
    if (!previousQuery.current?.subCategory && query.subCategory) {
      return true;
    }

    if (!previousQuery.current?.vehicle && query.vehicle) {
      return true;
    }
  }*/

  if (query.reference && (query.subCategory || query.vehicle)) {
    return true;
  }

  return false;
};
